import {SortBy, SingleSortOrder} from '../../Core';

export class SortController {
	constructor($scope, $location, searchService) {
		this.searchService = searchService;
		this.location = $location;
		this.sortBy = this.searchService.getSortByValue();
		this.sortOrder = this.searchService.getCurrentSortOrder();

		$scope.$watch( () => {
			return this.searchService.getSortByValue()
		}, () => {
			this.sortBy = this.searchService.getSortByValue();
		});

		$scope.$watch( () => {
			return this.searchService.getCurrentSortOrder()
		}, () => {
			this.sortOrder = this.searchService.getCurrentSortOrder();
		});
	}

	update() {
		var routeBuilder = this.searchService.getRouteBuilder();
		this.location.search(routeBuilder.getRoute());
		this.searchService.query();
	}

	setBy(by) {
		this.searchService.setSort(new SortBy({ id: 'sortBy', value: by}));
		this.update();
	}

	setByOrFlipOrder(by) {
		if (by === this.sortBy) {
			this.searchService.flipSortOrder();
		} else {
			this.searchService.setSort(new SortBy({ id: 'sortBy', value: by}));
		}

		this.update();

	}

	isSortedAsc(by) {
		return by === this.sortBy && this.sortOrder === 'asc'
	}

	isSortedDesc(by) {
		return by === this.sortBy && this.sortOrder === 'desc'
	}
}

SortController.$inject = ['$scope', '$location', 'searchService'];